var _mask, _mask2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNationalityCheckLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 52,
    viewBox: "0 0 56 52",
    width: 56,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 52,
    maskUnits: "userSpaceOnUse",
    width: 56,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 4.17934c0-2.30818 1.87116-4.17934 4.17934-4.17934h47.64136c2.3081 0 4.1793 1.87116 4.1793 4.17934v43.64136c0 2.3081-1.8712 4.1793-4.1793 4.1793h-47.64136c-2.30818 0-4.17934-1.8712-4.17934-4.1793z",
    fill: "#d0d7e2"
  }))), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    height: 70,
    maskUnits: "userSpaceOnUse",
    width: 70,
    x: -7,
    y: 26
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 27.9999,
    cy: 60.9999,
    fill: "#f1f3f4",
    r: 34.9999
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 20c0-4.4183 3.58172-8 8-8h40c4.4183 0 8 3.5817 8 8v24c0 4.4183-3.5817 8-8 8h-40c-4.41828 0-8-3.5817-8-8z",
    fill: "#d0d7e2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 27.9999,
    cy: 60.9999,
    fill: "#fff",
    r: 34.9999
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#dadee0",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "m37.9653 31.2502c.732-.549 3.5076-1.1438 4.8039-1.3726 5.4139 1.3726 16.9281 8.2811 19.6732 24.9346-4.804 0-2.5164 4.8039-2.9739 7.3203-1.0798 5.939-3.9651 1.9825-5.0327-.6863-.4575-3.4314-2.8366-6.4052-5.0326-5.4902-2.1961.915-5.9477-.3813-7.549-1.1438-1.2963-.305-3.5229-.5033-2.0589 1.1438 1.4641 1.6471 3.6602 2.3638 4.5752 2.5163 3.5839.6863 3.8889 2.7451-.915 4.1177-10.9206 3.1201-12.1242-8.0065-11.8954-9.8366.183-1.4641-3.2789-2.8976-5.0327-3.4314-3.2026-2.0588-1.1438-3.8889 0-4.3464 1.2385-.4954 4.1176.6863 5.0327-.915.732-1.281-.1525-1.9063-.6863-2.0588-.8388-.2288-3.2484 0-6.1765 2.7451-3.6601 3.4313-7.3202-1.1438-7.549-1.3726-.2287-.2287-.915-1.1438-2.0588-.915-.915.183-2.0588.0762-2.5163 0-1.1438-.2288-.915-1.3725-.2288-2.0588.6471-.647 3.5839-1.5251 5.0327-1.8301 1.7538-.0762 5.7647-.915 7.7778-3.6601 2.013-2.7451 5.7189-3.5839 7.3202-3.6601 1.525.2287 4.7582.549 5.4902 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.7431 35.5966c-1.46403-.5491-1.67753-2.2114-1.60128-2.9739 4.26988-3.4313 12.85528-9.2875 13.03828-5.2614.2288 5.0327-2.5163 8.6928-5.0318 7.0915-2.5154-1.6013-3.4322 0-3.6609 0-.2288 0-.9142 1.83-2.7443 1.1438z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.3109 42.6877c-2.74578-.183-5.1092 2.5163-5.9477 3.8889-.73202.366-.762521 1.22-.686269 1.6013.366009.915 1.220039.3812 1.601299 0 .22876-.5338 1.3268-1.4641 3.88888-.9151 2.56209.5491 3.50762-.6862 3.66013-1.3725.30526-.9913.22946-3.0196-2.51634-3.2026z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m1.92125 68.2875c-6.95433-5.8562-3.66016-12.0479-1.143788-14.4117 2.515998-2.0588 5.261758 0 9.608138-3.2026 3.4771-2.5621 6.329-.915 7.3203.2288.61.61 2.7451 1.83 6.4052 1.83 4.5751 0 4.3464 4.1177 4.8039 7.3203s.2287 2.2875 3.2026 6.4052c2.9738 4.1176 5.9477 2.5163 8.0065 3.2026s1.8301 3.4314 0 5.7189c-1.8301 2.2876-6.4052 2.7451-9.8366 5.0327-3.4313 2.2876-3.8888 5.2614-5.0326 7.7778-1.1438 2.5163-1.6013 2.9738-3.8889 3.4313s-4.3464-4.1176-4.3464-8.6928c0-4.5751-2.7451-8.2352-5.719-9.379-2.9738-1.1438-5.94799-2.7451-9.37935-5.2615z",
    opacity: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "m18.1666 3.80103-1.4696 1.8614c-.1959.8164-.5878 2.50799-.5878 2.74312 0 .2939-.5878 3.72275-.6858 4.11465-.0979.3919-.4898 3.8208-.4898 4.3106v4.1147c0 .4899.4898.5878 1.1756.9797s2.0574 0 2.5472 0h2.3512c.1568 0 2.286.1959 3.331.2939.8164.1306 2.5667.4311 3.037.5878.5878.196 1.6655.5878 2.5472.9797s2.3512.6858 2.8411.6858h3.135c.8817 0 2.0573-.5878 3.3309-.6858s.9797-1.3716.9797-1.5675v-3.6248c0-1.3716-.196-2.5472-.196-4.8985v-4.89838-2.84109c-1.1103-.09797-3.3897-.23512-3.6248 0-.2351.23513-2.3186.29391-3.3309.29391l-1.9594-.88172c-.5552-.26125-1.7438-.80334-2.0573-.88171-.3135-.07838-.9797-.48985-1.2736-.68578h-5.5842z",
    fill: "#3158f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.1666 3.80103-1.4696 1.8614c-.1959.8164-.5878 2.50799-.5878 2.74312 0 .2939-.5878 3.72275-.6858 4.11465-.0979.3919-.4898 3.8208-.4898 4.3106v4.1147c0 .4899.4898.5878 1.1756.9797s2.0574 0 2.5472 0h2.3512c.1568 0 2.286.1959 3.331.2939.8164.1306 2.5667.4311 3.037.5878.5878.196 1.6655.5878 2.5472.9797s2.3512.6858 2.8411.6858h3.135c.8817 0 2.0573-.5878 3.3309-.6858s.9797-1.3716.9797-1.5675v-3.6248c0-1.3716-.196-2.5472-.196-4.8985v-4.89838-2.84109c-1.1103-.09797-3.3897-.23512-3.6248 0-.2351.23513-2.3186.29391-3.3309.29391l-1.9594-.88172c-.5552-.26125-1.7438-.80334-2.0573-.88171-.3135-.07838-.9797-.48985-1.2736-.68578h-5.5842z",
    fill: "#3158f2"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#3158f2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.7761 35.2359v-29.96246",
    strokeWidth: 3.13499
  }), /*#__PURE__*/React.createElement("path", {
    d: "m40.3503 22.6308v-17.58783",
    strokeWidth: 2.6329
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7773 22.5944s1.5359-1.276 6.1435-1.276 7.6793 3.0313 12.2869 3.0313 6.1434-1.7149 6.1434-1.7149",
    strokeWidth: 2.6329
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7773 4.92497s1.5359-1.63591 6.1435-1.63591 7.6793 3.03135 12.2869 3.03135 6.1434-1.27608 6.1434-1.27608",
    strokeWidth: 2.6329
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNationalityCheckLarge);
export default __webpack_public_path__ + "static/media/nationality_check_large.6a00a007cf667b343d47044346f7d639.svg";
export { ForwardRef as ReactComponent };